
import { Vue, Component, Prop, Model } from 'vue-property-decorator'

@Component
export default class RefuseDialog extends Vue {
  @Model('change', { type: Boolean }) private readonly refuseDialog!: boolean
  private get refuseDialog_() {
    return this.refuseDialog
  }
  private set refuseDialog_(value) {
    this.$emit('change', value)
  }

  private reason = ''


  get btnDisabler() {
    return (/^\s+$/.test(this.reason) ||
      /  /.test(this.reason) ||
      this.reason.replace(' ', '').length <= 9 ||
      this.reason.length > 98)
  }
}
